import { Component } from '@angular/core';

/**
 * libs
*/
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * utilities
 */
import { LocalizedNumberPipe } from '@core/utilities';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  imports: [
    AsyncPipe,
    /**
     * pipes
     */
    TranslatePipe,
    LocalizedNumberPipe,
  ],
})
export class FooterComponent {

  /**
   * getter for the current date
   */
  public currentDate: Date = new Date()

  /**
   * getter for the current year
   */
  public get currentYear(): number {
    return this.currentDate.getFullYear();
  }

}